var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('moment-to-moment-ratings',{attrs:{"title":_vm.title,"minValue":_vm.minValue,"maxValue":_vm.maxValue,"minLabel":_vm.minLabel,"maxLabel":_vm.maxLabel,"active":true},on:{"change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }